import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';

export const openMultiUpdateActivity = asyncModalAdapter({
	featureFlag: 'REACT_MULTI_UPDATE_ACTIVITY',
	openModalName: 'MultiUpdateActivity',
	upModalName: 'updateActivityMulti',
	rejectOnEvent: true
});
